import { useEffect } from 'react';

// 统一的语言数据配置
export const LANGUAGE_DATA = [
  {
    name: 'Chinese',
    value: 'zh',
    icon: '/images/country/flag-cn.png',
    labelKey: 'merror.language.original.chi',
  },
  {
    name: 'English',
    value: 'en',
    icon: '/images/country/flag-us.png',
    labelKey: 'merror.language.original.eng',
  },
  {
    name: 'Japanese',
    value: 'ja',
    icon: '/images/country/flag-jp.png',
    labelKey: 'merror.language.target.jap',
  },
  {
    name: 'Korean',
    value: 'ko',
    icon: '/images/country/flag-kr.png',
    labelKey: 'merror.language.target.kr',
  },
  {
    name: 'German',
    value: 'de',
    icon: '/images/country/flag-de.png',
    labelKey: 'merror.language.target.ger',
  },
  {
    name: 'French',
    value: 'fr',
    icon: '/images/country/flag-fr.png',
    labelKey: 'merror.language.target.france',
  },
  {
    name: 'Russian',
    value: 'ru',
    icon: '/images/country/flag-ru.png',
    labelKey: 'merror.language.target.rus',
  },
  {
    name: 'Spanish',
    value: 'es',
    icon: '/images/country/flag-es.png',
    labelKey: 'merror.language.target.spa',
  },
  {
    name: 'Filipino',
    value: 'tl',
    icon: '/images/country/flag-ph.png',
    labelKey: 'merror.language.target.fil',
  },
  {
    name: 'Hindi',
    value: 'hi',
    icon: '/images/country/flag-in.png',
    labelKey: 'merror.language.target.hindi',
  },
  {
    name: 'Thai',
    value: 'th',
    icon: '/images/country/flag-th.png',
    labelKey: 'merror.language.target.thai',
  },
  {
    name: 'Italian',
    value: 'it',
    icon: '/images/country/flag-it.png',
    labelKey: 'merror.language.target.italian',
  },
  {
    name: 'Malay',
    value: 'ms',
    icon: '/images/country/flag-my.png',
    labelKey: 'merror.language.target.malay',
  },
  {
    name: 'Indonesian',
    value: 'id',
    icon: '/images/country/flag-id.png',
    labelKey: 'merror.language.target.indo',
  },
  {
    name: 'Ukrainian',
    value: 'uk',
    icon: '/images/country/flag-ua.png',
    labelKey: 'merror.language.target.ukrainian',
  },
  {
    name: 'Swedish',
    value: 'sv',
    icon: '/images/country/flag-se.png',
    labelKey: 'merror.language.target.swedish',
  },
  {
    name: 'Vietnamese',
    value: 'vi',
    icon: '/images/country/flag-vn.png',
    labelKey: 'merror.language.target.vietnamese',
  },
  {
    name: 'Arabic',
    value: 'ar',
    icon: '/images/country/flag-ar.png',
    labelKey: 'merror.language.target.arbic',
  },
  {
    name: 'Bulgarian',
    value: 'bg',
    icon: '/images/country/flag-bg.png',
    labelKey: 'merror.language.target.bulgarian',
  },
  {
    name: 'Portuguese',
    value: 'pt',
    icon: '/images/country/flag-pt.png',
    labelKey: 'merror.language.target.portuguese',
  },
  {
    name: 'Czech',
    value: 'cs',
    icon: '/images/country/flag-cz.png',
    labelKey: 'merror.language.target.czech',
  },
  {
    name: 'Danish',
    value: 'da',
    icon: '/images/country/flag-dk.png',
    labelKey: 'merror.language.target.danish',
  },
  {
    name: 'Greek',
    value: 'el',
    icon: '/images/country/flag-gr.png',
    labelKey: 'merror.language.target.greek',
  },
  {
    name: 'Finnish',
    value: 'fi',
    icon: '/images/country/flag-fi.png',
    labelKey: 'merror.language.target.finnish',
  },
  {
    name: 'Croatian',
    value: 'hr',
    icon: '/images/country/flag-hr.png',
    labelKey: 'merror.language.target.croatian',
  },
  {
    name: 'Norwegian',
    value: 'no',
    icon: '/images/country/flag-no.png',
    labelKey: 'merror.language.target.norwegian',
  },
  {
    name: 'Dutch',
    value: 'nl',
    icon: '/images/country/flag-nl.png',
    labelKey: 'merror.language.target.dutch',
  },
  {
    name: 'Polish',
    value: 'pl',
    icon: '/images/country/flag-pl.png',
    labelKey: 'merror.language.target.polish',
  },
  {
    name: 'Tamil',
    value: 'ta',
    icon: '/images/country/flag-tam.png',
    labelKey: 'merror.language.target.tamil',
  },
  {
    name: 'Turkish',
    value: 'tr',
    icon: '/images/country/flag-tr.png',
    labelKey: 'merror.language.target.turkish',
  },
  {
    name: 'Romanian',
    value: 'ro',
    icon: '/images/country/flag-ro.png',
    labelKey: 'merror.language.target.romanian',
  },
  {
    name: 'Slovak',
    value: 'sk',
    icon: '/images/country/flag-sk.png',
    labelKey: 'merror.language.target.slovak',
  },
  {
    name: 'Urdu',
    value: 'ur',
    icon: '/images/country/flag-ur.png',
    labelKey: 'merror-language-target-urdu',
  },
  {
    name: 'Cantonese',
    value: 'yue',
    icon: '/images/country/flag-yue.png',
    labelKey: 'merror-language-target-cantonese',
  },
] as const;

// 语言代码类型（从 LANGUAGE_DATA 中提取）
export type LanguageCode = (typeof LANGUAGE_DATA)[number]['value'];

// 原文语言支持的语言代码列表
const ORIGIN_LANG_CODES = [
  'zh',
  'en',
  'ja',
  'ko',
  'de',
  'fr',
  'ru',
  'es',
  // 'tl', // Filipino
  'hi',
  // 'th', // Thai
  'it',
  'ms',
  'id',
  'uk',
  'sv',
  'vi',
  'ar',
  'bg',
  'pt',
  'cs',
  'da',
  // 'el', // Greek
  // 'fi', // Finnish
  'hr',
  'no',
  'nl',
  'pl',
  'ta',
  'tr',
  'ro',
  'sk',
  // 'ur', // Urdu
];

// 目标语言支持的语言代码列表
const TARGET_LANG_CODES = [
  'zh',
  'en',
  'ja',
  'ko',
  'de',
  'fr',
  'ru',
  'es',
  'tl',
  'hi',
  'th',
  'it',
  'ms',
  'id',
  'uk',
  'sv',
  'vi',
  'ar',
  'bg',
  'pt',
  'cs',
  'da',
  'el',
  'fi',
  'hr',
  'no',
  'nl',
  'pl',
  'ta',
  'tr',
  'ro',
  'sk',
  // 'ur', // Urdu
  'yue',
];

// 根据语言代码获取语言名称
export const getLanguageNameByCode = (code: string): string => {
  const language = LANGUAGE_DATA.find((lang) => lang.value === code);
  return language?.name || code;
};

export const useTranslationConfig = (t: any) => {
  // 根据语言代码列表生成带 label 的语言数组
  const buildLangList = (codes: string[]) => {
    return codes
      .map((code) => {
        const lang = LANGUAGE_DATA.find((l) => l.value === code);
        if (!lang) return null;
        return {
          label: t(lang.labelKey),
          name: lang.name,
          value: lang.value,
          icon: lang.icon,
        };
      })
      .filter(Boolean) as { label: string; name: string; value: string; icon: string }[];
  };

  const originLang = buildLangList(ORIGIN_LANG_CODES);
  const targetLang = buildLangList(TARGET_LANG_CODES);

  // 服务端渲染时需要使用 useEffect
  useEffect(() => {
    if (navigator.language !== 'zh-CN') {
      originLang.sort((a, b) => a.name.localeCompare(b.name));
      targetLang.sort((a, b) => a.name.localeCompare(b.name));
    }
  }, []);

  originLang.unshift({
    label: t('auto-detect'),
    name: 'AutoDetect',
    value: 'autoDetectLang',
    icon: '',
  });

  return [originLang, targetLang];
};
